import { ChangeEvent } from 'react';
import { v1 as uuid } from 'uuid';
import cloneDeep from 'lodash/cloneDeep';
import { SpaceBetween } from 'utils/style/extendable';
import { CollectionItem, ItemAvatar, CollectionContent } from './styles';
import ItemView, {
  IComponentProps as IComponentBaseProps,
  IComponentState as IComponentBaseState,
} from './ItemView';
import Button from 'components/Button';
import image from 'assets/images/link.svg';
import Input from '../../../../components/Input/Input';
import { item_createNewExternalLink } from 'store/providers/providerSlice';
import { gray } from '../../../../utils/style/colors';
import i18n from '../../../../i18n';
import LocalIcon, { LocalIconTypes } from '../../../../ui/LocalIcon';
import { IUsers } from '../../../../store/store';
import { IProviderItemViewWithData } from '../../../../store/providers/providerTypes';

interface IComponentProps extends IComponentBaseProps {
  listIndex?: number;
  onOpenFolder?: (index: number, id: number) => void;
  users?: IUsers;
}

interface IComponentState extends IComponentBaseState {
  url: string;
  name: string;
}

class ExternalLinkView extends ItemView<IComponentProps, IComponentState> {
  protected linkImage;
  protected nameId;
  protected urlId;
  constructor(props: IComponentProps) {
    const viewTypeList = props.item.data?.viewType?.split(',');
    super(props);
    this.state = {
      url: '',
      name: '',
      rename: false,
      loading: false,
      showDropdown: false,
      showTaskModal: undefined,
      showContentTasksList: false,
      relatedTemplateId: undefined,
      showChangeLimitationModal: false,
      showDeleteModal: false,
      activeLanguage: null,
      openThumbnail: false,
      modalTitle: 'string',
      editLink: false,
      enableDisplayModeModal: false,
      displayMode:
        (viewTypeList?.find((el: string) =>
          el.startsWith('display_')
        ) as IComponentState['displayMode']) || 'display_sm',
      isItemTemplateModeIsLarge: viewTypeList?.find((el: string) =>
        el.startsWith('card_lg')
      )
        ? true
        : false,
      isIsolatedHtml: false,
    };
    this.linkImage = image;
    this.nameId = uuid();
    this.urlId = uuid();
  }

  handelConfirmCreatingNewItem = (item: IProviderItemViewWithData) => {
    if (this.state.url) {
      const newItem = cloneDeep(item.data);
      newItem.url = this.state.url;
      newItem.name = this.state.name;
      newItem.order = this.props.expectedOrder;
      this.props.dispatch(item_createNewExternalLink({ item: newItem }));
    }
  };

  deleteItemTitle = (name: string) => {
    return i18n.t('deleteExternalLinkTitle', { ns: 'documentManager', name });
  };

  deleteItemMessage = (name: string) => {
    return i18n.t('deleteExternalLinkMessage', { ns: 'documentManager', name });
  };

  onOpenFunction = (item: IProviderItemViewWithData) => {
    return () => {
      const url = item.data.url;
      (window.open(url, '_blank') as any)?.focus();
    };
  };

  getThumbnail = () => {
    return ['link.svg', gray];
  };

  createNewItem = (item: IProviderItemViewWithData) => {
    return (e: ChangeEvent<HTMLFormElement>) => {
      e.preventDefault();
      this.handelConfirmCreatingNewItem(item);
    };
  };

  newItemPlaceHolder = () => {
    return i18n.t('newExternalLinkPlaceholder', {
      ns: 'documentManager',
      name,
    });
  };

  newItemTitle = () => {
    return i18n.t('newExternalLinkTitle', { ns: 'documentManager', name });
  };

  handleUrlChange = (event: ChangeEvent<HTMLInputElement>) => {
    this.setState({ url: event.target.value });
  };

  handleNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    this.setState({ name: event.target.value });
  };

  getMenuActions(itemId: number, editable: boolean) {
    const menuActions = super.getMenuActions(itemId, editable);

    if (editable) {
      menuActions.push({
        message: i18n.t('editLinkAddress', { ns: 'documentManager' }),
        callBack: () => {
          this.setState({ editLink: true });
        },
        order: 0,
        group: '1-actions',
        icon: 'edit',
        color: 'blue',
      });
    }
    return menuActions;
  }

  getCreatingView = () => {
    const [iconType, iconColor] = this.getThumbnail();
    return (
      <CollectionItem>
        <CollectionContent>
          <ItemAvatar>
            <LocalIcon
              iconName={iconType as LocalIconTypes}
              color={iconColor}
              type="lg"
            />
          </ItemAvatar>
          <form onSubmit={this.createNewItem(this.props.item)}>
            <div>
              <Input
                id={this.nameId}
                type="text"
                autoComplete="off"
                required={true}
                defaultValue=""
                onChange={this.handleNameChange}
                placeholder={this.newItemTitle()}
                label={
                  i18n.t('newExternalLinkTitle', {
                    ns: 'documentManager',
                  }) as string
                }
              />
            </div>
            <div>
              <Input
                id={this.urlId}
                type="text"
                autoComplete="off"
                required={true}
                defaultValue=""
                onChange={this.handleUrlChange}
                placeholder="http://..."
                label={i18n.t('url', { ns: 'documentManager' }) as string}
              />
            </div>
            <SpaceBetween>
              <Button type="submit" color="green" disabled={!this.state.url}>
                {i18n.t('confirm', { ns: 'documentManager' }) as string}
              </Button>
              <Button
                color="red"
                onClick={this.handelCancelCreatingNewItemFunction}
              >
                {i18n.t('cancel', { ns: 'documentManager' }) as string}
              </Button>
            </SpaceBetween>
          </form>
        </CollectionContent>
      </CollectionItem>
    );
  };
}

export default ExternalLinkView;
